var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-chat-room"},[(Object.keys(_vm.anchormanInfo).length > 0 && Object.keys(_vm.chatlist).length > 0)?_c('div',{staticClass:"lcr-head"},[_c('chat-room',{attrs:{"liveData":_vm.anchormanInfo,"liveId":_vm.anchormanInfo.liveCtId,"userData":_vm.anchormanInfo,"chatlist":_vm.chatlist,"sendDame":_vm.sendDame}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }